import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=cfae53bc&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&lang=ts&"
export * from "./MyAccount.vue?vue&type=script&lang=ts&"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=cfae53bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfae53bc",
  null
  
)

export default component.exports